import React from 'react'
import { Tag } from 'antd'
import { t } from 'i18next'

export function SlotStateTag ({ slot, state }) {
  const slotState = state || slot?.state
  return (
    <Tag color={t(`Admin.Slot.stateColor.${slotState}`)}>
      {t(`Admin.Slot.state.${slotState}`)}
    </Tag>
  )
}

export function BoxStateTag ({ box, state }) {
  const boxState = state || box?.state
  return (
    <Tag color={t(`Admin.Box.stateColor.${boxState}`)}>
      {t(`Admin.Box.state.${boxState}`)}
    </Tag>
  )
}
export function ConsultationStateTag ({ slot }) {
  const consultationState = slot?.consultation_done
  return (
    <>
      {slot.type === 'PatientSlot' &&
        <Tag color={t(`Admin.Slot.consultationColor.${consultationState}`)}>
          {t(`Admin.Slot.consultation.${consultationState}`)}
        </Tag>
      }
    </>
  )
}

export default function StateTag ({ slot, boxes }) {
  const box = boxes.find((e) => e.id === slot.box.id)
  const isCurrentSlot = slot.id === box?.current_slot?.id

  return (
    <>
      <SlotStateTag slot={slot} />
      {isCurrentSlot && <BoxStateTag box={box} />}
      <ConsultationStateTag slot={slot} />
    </>
  )
}
